import { Trash2, FileSpreadsheet, Database } from "lucide-react";
import { AppColorVariant } from "../../theme/AppColorVariant";

export enum JobType {
  Delete = "delete",
  ExportCsv = "exportCsv",
  SqlScriptExecute = "sqlScriptExecute",
}
export const JobTypeLabels: Record<JobType, string> = {
  [JobType.Delete]: "Delete",
  [JobType.ExportCsv]: "Export CSV",
  [JobType.SqlScriptExecute]: "SQL Script",
};

export const JobTypeColors: Record<JobType, AppColorVariant> = {
  [JobType.Delete]: "danger",
  [JobType.ExportCsv]: "success",
  [JobType.SqlScriptExecute]: "warning",
};

export const JobTypeIcons: Record<JobType, React.ElementType> = {
  [JobType.Delete]: Trash2,
  [JobType.ExportCsv]: FileSpreadsheet,
  [JobType.SqlScriptExecute]: Database,
};
